import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const WebContentSurveyEndPage = () => {
    const navigate = useNavigate();

    // Redirect to /wc in the browser's top window to leave the iframe
    useEffect(() => {
        if (window.top !== window.self) {
            window.top.location.href = '/wc';
        } else {
            navigate('/wc', { replace: true });
        }
    }, [navigate]);

    return null;
};

export default WebContentSurveyEndPage;